import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {StorageService} from "../../services/storage.service";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {inputErrorAnimation} from "../../animation/animation";
import {ButtonComponent} from "../common/button/button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    NgIf
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  animations: [
    inputErrorAnimation
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  form!: FormGroup;
  isLoading = false;
  errorMessage = '';

  subLogin?: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  ngOnDestroy(): void {
    this.subLogin?.unsubscribe();
  }

  onSubmit(): void {
    this.markFormAsAllTouched();
    if (this.form.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    const {username, password} = this.form.value;

    this.authService.logIn(username, password).subscribe(
      response => {
        this.isLoading = false;
        if(!response) {
          this.errorMessage = 'Invalid username or password';
          return;
        }
        this.storageService.setUser(response?.staff);
        this.router.navigate(['/']);
      });
  }

  markFormAsAllTouched() {
    this.form.markAllAsTouched();
  }

  showErrorState(formControlName: string) {
    let control = this.form.controls[formControlName];
    return (control && control.invalid && (control.dirty || control.touched));
  }
}
